/** `<input type="datetime-local">` values (the browser's local time) ↔ ISO instants for the API. */

/** "2026-10-01T10:30" → "2026-10-01T05:00:00.000Z" (null when empty or invalid). */
export function toInstant(local: string): string | null {
  if (!local.trim()) return null;
  const date = new Date(local);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}

/** ISO instant → "2026-10-01T10:30" in the browser's time ("" when empty). */
export function toLocalInput(iso: string | null | undefined): string {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** "9 Oct 2026, 10:30 am" in the user's language. */
export function formatDateTime(iso: string, language: string): string {
  return new Intl.DateTimeFormat(language, { dateStyle: "medium", timeStyle: "short" }).format(
    new Date(iso),
  );
}
